import { useEffect, type MutableRefObject } from 'react';

import { createHook } from 'react-sweet-state';

import type { AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service/services/assistance-service/main';

import { store } from './store';
import {
	useThirdPartySuggestedPromptTile,
	type ThirdPartySuggestedPromptTile,
} from './useThirdPartySuggestedPromptTile';

const useTilesDisplayed = createHook(store, {
	selector: (state) => (state.primaryPrompts?.length ?? 0) > 0,
});

/** Mount independently from the UI so eligibility changes cannot recreate the consumer. */
export const ThirdPartyPromptSuggestionsController = ({
	assistanceServiceParams,
	onDecisionChange,
	hasReportedExposureRef,
}: AssistanceServiceInputParam & {
	onDecisionChange: (decision: ThirdPartySuggestedPromptTile) => void;
	hasReportedExposureRef: MutableRefObject<boolean>;
}): null => {
	const [tilesDisplayed] = useTilesDisplayed();
	const { enable3pPrompt, ready } = useThirdPartySuggestedPromptTile({
		assistanceServiceParams,
		tilesDisplayed,
		hasReportedExposureRef,
	});
	useEffect(() => {
		onDecisionChange({ enable3pPrompt, ready });
	}, [enable3pPrompt, ready, onDecisionChange]);
	return null;
};
